import React, {Component} from 'react';
import Table from '../../../../components/Table';
import EventFormModal from './components/EventFormModal'
import EventDetailModal from './components/EventDetailModal'
import DeleteEventModal from './components/DeleteEventModal'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from 'moment';
import Switch from "react-switch";
import _ from "lodash";


class Events extends Component {
    static contextTypes = {api: PropTypes.object};

    constructor(props) {
        super(props);
        this.state = {
            addingEvent: false
        };
        this.loadData = _.debounce(this.loadData, 450);

    }

    loadData = (tableState) => {
        this.tableState = tableState;
        const filters = {...tableState.filters, 'order[id]': 'DESC'};
        this.context.api.events.get(tableState.page, tableState.pageSize, '@Class.Events.events.get', filters)
    };

    openAddEvent = () => this.setState({addingEvent: true});

    closeAddEvent = () => {
        this.loadData(this.tableState);
        this.setState({addingEvent: false});
    };

    onDetailEvent = event => this.setState({detailingEvent: event});

    closeDetailEvent = () => this.setState({detailingEvent: false});

    onEditEvent = e => {
        e.stopPropagation();
        this.setState({editingEvent: e.currentTarget.dataset.index})
    };

    closeEditEvent = () => this.setState({editingEvent: false});

    onDeleteEvent = e => {
        e.stopPropagation();
        this.setState({deletingEvent: e.currentTarget.dataset.index})
    };

    deleteEvent = event => {
        this.closeDeleteEvent();
        this.context.api.events.delete(event.id)

    };

    closeDeleteEvent = () => {
        return this.setState({deletingEvent: false})
    };

    onChangeTimeTideClockEnabled = (eventId, isEnabled, event) => {
        event.stopPropagation();
        this.context.api.events.edit(eventId, {hasTimeTideClockEnabled: isEnabled}).then(() => {
            const filters = {'order[id]': 'DESC'};
            this.context.api.events.get(0, 100, '@Class.Events.events.get', filters)
        });

    };

    tableDefinition =
        [
            {
                name: 'Acciones',
                accessor: (data, index) =>
                    <span>
                        <button className='btn btn-xs btn-primary' data-index={index} onClick={this.onEditEvent}><i
                            className='ti-pencil'/></button>
                        &nbsp;
                        <button className='btn btn-xs btn-danger' data-index={index} onClick={this.onDeleteEvent}><i
                            className='ti-trash'/></button>
                    </span>
            },
            {
                name: 'Nombre',
                id: 'name',
                filterable: true,
                accessor: 'name',
            },
            {
                name: 'Congreso',
                id: 'congress.name',
                filterable: true,
                accessor: (event) => event.congress ? event.congress.name : 'N/A'

            },
            {
                name: 'Fecha de inicio',
                id: 'from',
                filterable: true,
                accessor: (event) => event.fromDate && moment(event.fromDate).format('DD/MM/YYYY HH:mm')
            }, {
            name: 'Fecha de fin',
            id: 'to',
            accessor: (event) => event.toDate && moment(event.toDate).format('DD/MM/YYYY HH:mm')
        }, {
            name: 'Conectar con reloj inteligente',
            id: 'hasTimeTideClockEnabled',
            accessor: (event) => (
                <Switch
                    onChange={(value, e) => this.onChangeTimeTideClockEnabled(
                        event.id,
                        value,
                        e
                    )}
                    checked={!!event.hasTimeTideClockEnabled}/>
            )
        }
        ];

    render() {
        return (
            <div className="container-fluid Directory">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Listado de eventos y talleres</h4>
                            </div>
                            <div className="card-content">
                                <div className='buttonContainer'>
                                </div>
                                <div className='buttonContainer'>
                                    <button className='btn btn-success btn-fill btn-magnify pull-right'
                                            onClick={this.openAddEvent}>
                                        <span className='btn-label'><i className='ti-plus'/></span>
                                    </button>
                                    <a href={this.context.api.events.exportUrl(this.tableState ? {...this.tableState.filters} : null, 'xlsx')}>
                                        <button
                                            className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                            <span className='btn-label'>Descargar excel</span>
                                        </button>
                                    </a>
                                    <a href={this.context.api.events.exportUrl(this.tableState ? {...this.tableState.filters} : null, 'pdf')}>
                                        <button
                                            className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                            <span className='btn-label'>Descargar PDF</span>
                                        </button>
                                    </a>
                                    <div className='clearfix'/>
                                </div>
                                <br/>
                                <Table
                                    paginated
                                    defaultPageSize={50}
                                    rowIdAccessor={'id'}
                                    totalItems={this.props.eventsMeta.totalItems}
                                    loadData={this.loadData}
                                    columns={this.tableDefinition}
                                    data={this.props.events}
                                    trProps={(event) => ({onClick: () => this.onDetailEvent(event)})}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*New event Modal */}
                {this.state.addingEvent ?
                    <EventFormModal
                        onHide={this.closeAddEvent}
                    /> : null}
                {/*  Edit event Modal */}
                {this.state.editingEvent ?
                    <EventFormModal
                        onHide={this.closeEditEvent}
                        editing={this.props.events[this.state.editingEvent]}
                    /> : null}
                {/* Delete event Modal*/}
                {this.state.deletingEvent ?
                    <DeleteEventModal
                        event={this.props.events[this.state.deletingEvent]}
                        onHide={this.closeDeleteEvent}
                        onConfirm={this.deleteEvent}
                    /> : null}
                {/* Show event detail Modal*/}
                {this.state.detailingEvent ?
                    <EventDetailModal
                        event={this.state.detailingEvent}
                        onHide={this.closeDetailEvent}
                    />
                    : null}
            </div>
        );
    }
}

const mapStateToProps = ({api: {events = [], eventsMeta = {}}}) => {
    return {events, eventsMeta}
};

export default connect(mapStateToProps)(Events);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Events/index.jsx